import { render, staticRenderFns } from "./Createcourse.vue?vue&type=template&id=9be32aa8"
import script from "./Createcourse.vue?vue&type=script&lang=js"
export * from "./Createcourse.vue?vue&type=script&lang=js"
import style0 from "./Createcourse.vue?vue&type=style&index=0&id=9be32aa8&prod&lang=less"
import style1 from "./Createcourse.vue?vue&type=style&index=1&id=9be32aa8&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports